<template>
	<div class="photo">
		<div class="photo-content">
			<div class="close-video" @click="closePhoto">
				<i class="el-icon-close"></i>
			</div>
			<div class="video-area">
				<video id="video" autoplay="autoplay" v-show="face==''"></video>
				<img :src="face" v-show="face!=''">
			</div>
			<!--拍照按钮-->
			<div class="photo-button">
				<el-button id="capture" type="primary" v-show="face==''" icon="el-icon-camera">点击拍照</el-button>
				<el-button type="primary" @click="rePhoto" v-show="face!=''" icon="el-icon-refresh-left">重新拍照</el-button>
				<el-button type="success" @click="enterPhoto" v-show="face!=''" icon="el-icon-check">使用照片</el-button>
			</div>
			<!--描绘video截图-->
			<canvas id="canvas" width="600" height="450"></canvas>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'photo',
		data() {
			return {
				face: '',
				stream: {}
			};
		},
		methods: {
			rePhoto() {
				this.face = ''
				this.initPhoto()
			},
			enterPhoto(){
				this.$emit('enterPhoto',this.face)
				this.closePhoto()
			},
			closePhoto(){
				this.stream.getTracks().forEach(track => track.stop());
				this.$message({
					message: '摄像头已关闭！',
					type: 'success'
				});
				this.$emit('closePhoto')
			},
			initPhoto() {
				let that = this
				let video = document.getElementById("video");
				let canvas = document.getElementById("canvas");
				let context = canvas.getContext("2d");

				// 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
				if (navigator.mediaDevices === undefined) {
					navigator.mediaDevices = {};
				}

				// 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
				// 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
				if (navigator.mediaDevices.getUserMedia === undefined) {
					navigator.mediaDevices.getUserMedia = function(constraints) {

						// 首先，如果有getUserMedia的话，就获得它
						var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

						// 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
						if (!getUserMedia) {
							return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
						}

						// 否则，为老的navigator.getUserMedia方法包裹一个Promise
						return new Promise(function(resolve, reject) {
							getUserMedia.call(navigator, constraints, resolve, reject);
						});
					}
				}
				//默认使用前摄像头，强制使用后置摄像头如下设置
				// let constraints = {video: { facingMode: { exact: "environment" } }};
				let constraints = {
					video: true
				};
				navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
					that.stream = stream
					// 旧的浏览器可能没有srcObject
					if ("srcObject" in video) {
						video.srcObject = stream;
					} else {
						// 防止在新的浏览器里使用它，应为它已经不再支持了
						video.src = window.URL.createObjectURL(stream);
					}
					video.onloadedmetadata = function(e) {
						video.play();
					};
				}).catch(function(err) {
					console.log(err.name + ": " + err.message);
				});

				//注册拍照按钮的单击事件
				document.getElementById("capture").addEventListener("click", function() {
					//绘制画面
					context.drawImage(video, 0, 0, 600, 450)
					that.face = canvas.toDataURL('image/png', 1)
				});
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.initPhoto()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.photo {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 999;
		background: @vue-bg-color-mask;
		display: flex;
		justify-content: center;
		align-items: center;

		.photo-content {
			width: 900px;
			height: 600px;
			background: @vue-bg-color;
			border-radius: @vue-border-radius-lg;
			position: relative;
			.close-video{
				width: 30px;
				height: 30px;
				position: absolute;
				right: 10px;
				top: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: @vue-font-size-base;
				cursor: pointer;
			}
			.video-area {
				width: 600px;
				height: 450px;
				display: flex;
				justify-content: center;
				align-items: center;
				border: 2px solid #007AFF;
				box-sizing: border-box;
				margin: 0px  auto;
				margin-top: @vue-spacing-col-base*2;
				video,
				img {
					width: 100%;
					height: 100%;
				}
			}
			.photo-button {
				width: 100%;
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: @vue-spacing-col-lg;
			
				.el-button {
					width: 300px;
					height: 40px;
					border-radius: 20px;
				}
			}
			
			canvas {
				width: 600px;
				height: 450px;
				opacity: 0;
			}
		}
	}
</style>
